import React, { useEffect, useState, useRef, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import * as cts from '../../../constants/ui/svg';
import { IMAGE_BASE_URL_OF_USER } from '../../../constants';
import { message, Upload } from 'antd';
import {
  isValidImageUrl,
  createFileFromUrl,
  createLocalImageFromUrl,
} from '../../../helpers/functionHelper';
import type { RcFile } from 'antd/es/upload/interface';
import { LoadingOutlined } from '@ant-design/icons';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { rankingAction } from 'slices/rankingSlice';
import { getToken } from 'helpers';

type Props = {
  item: any;
  index: number;
  setSelectedStaff: React.Dispatch<React.SetStateAction<object>>;
  setOpenModalViewImage: React.Dispatch<React.SetStateAction<boolean>>;
  loading: boolean;
  setListStaff: React.Dispatch<React.SetStateAction<any>>;
  listStaff: any;
  setOpenModalChangeImage: React.Dispatch<React.SetStateAction<boolean>>;
  setOpenModalDeleteImage: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function ItemOfStaffImage({
  item,
  index,
  setSelectedStaff,
  setOpenModalViewImage,
  loading,
  setListStaff,
  listStaff,
  setOpenModalChangeImage,
  setOpenModalDeleteImage,
}: Props) {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const token = getToken() as string;
  const selectShop = useAppSelector((state) => state.shopList.selectShop);

  const [imageError, setImageError] = useState(false);
  const [open, setOpen] = useState(false);
  // ----INPUT UPLOAD-----
  const inputRef = useRef<any>();
  const imageMimeType = /image\/(png|jpg|jpeg|webp)/i;
  const changeHandler = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (!file?.type?.match(imageMimeType)) {
      alert('Image mime type is not valid');
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const result = reader.result;
      if (result) {
        const staffIndex = listStaff.findIndex((x: any) => x.id === item.id);
        const newListStaff = [...listStaff];
        if (staffIndex !== -1) {
          const updatedStaff = {
            ...newListStaff[staffIndex],
            imageUrl: result,
            image_app_pos_ranking: file,
            // avatar_ranking: null,
            isUpdateImagePosRanking: true,
          };
          newListStaff[staffIndex] = updatedStaff;
          setListStaff([...newListStaff]);
          // setSelectedStaff(item);
          setSelectedStaff(updatedStaff);
          setOpenModalChangeImage(true);
        }
      }
    };
    reader.readAsDataURL(file);
  };

  // ----INPUT UPLOAD-----

  //   let mounted = true;

  //   const check = async () => {
  //     const result = await isValidImageUrl(
  //       `${IMAGE_BASE_URL_OF_USER}/avatar_ranking_user_shop/${item?.avatar_ranking}`
  //     );
  //     if (mounted) setValid(result);
  //   };

  //   check();

  //   return () => {
  //     mounted = false;
  //   };
  // }, [item?.image_app_pos_ranking]);
  // const imageSrc = useMemo(() => {
  //   if (item?.imageUrl) return item.imageUrl;

  //   return `${IMAGE_BASE_URL_OF_USER}/avatar_ranking_user_shop/${item.avatar_ranking}?v=${item?.updated_at}`;
  // }, [item]);
  const imageSrc = useMemo(() => {
    if (item?.imageUrl) return item.imageUrl;

    return `${IMAGE_BASE_URL_OF_USER}/avatar_ranking_user_shop/${
      item.avatar_ranking
    }?ts=${Date.now()}`;
  }, [item.avatar_ranking]);
  return (
    <div
      key={index}
      className="flex items-center justify-between py-[16px] border-b border-solid border-[#D5D7DA]"
    >
      <span className="text-[#252B37] text-[14px] notosans_normal">{item?.nick_name}</span>

      {item?.avatar_ranking && !imageError ? (
        <div className="flex items-center gap-5">
          <div
            onClick={() => {
              setSelectedStaff(item);
              setOpenModalChangeImage(true);
            }}
            className="relative cursor-pointer"
          >
            <img
              className="h-20 w-20h-20 rounded-[8px] object-cover"
              src={imageSrc}
              onError={() => setImageError(true)}
            />
          </div>
          <button
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              setSelectedStaff(item);
              setOpenModalDeleteImage(true);
            }}
            className="rounded-lg border border-solid border-[#F04438] h-10 w-10 flex items-center justify-center"
          >
            {cts.trashIcon}
          </button>
        </div>
      ) : (
        <>
          <input
            id="inputAvatar"
            ref={inputRef}
            accept=".png, .jpg, .jpeg, .webp"
            type="file"
            onChange={changeHandler}
            className="hidden"
          />
          <button
            onClick={() => inputRef.current?.click()}
            className="h-[80px] flex-col w-[80px] rounded-[8px] border border-[#D5D7DA] border-dashed flex items-center justify-center"
          >
            <span>{cts.plus}</span>
            <span className=" text-[#A4A7AE] text-[12px] notosans_normal">{t('UPLOAD')}</span>
          </button>
        </>
      )}
    </div>
  );
}
